import { makeObservable, observable, action } from 'mobx'
import { dateFormattedSlash } from 'util/dateHelper'

class Notification {
    constructor(id, configuration, destination, metadata, type) {
        this.id = id
        this.description = configuration?.body
        this.title = configuration?.title
        this.highlight = !configuration?.read
        this.redirectTo = destination?.referTo
        this.type = type
        this.metadata = metadata
        this.createdAt = ''
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false

        makeObservable(this, {
            isNewlyAdded: observable,
            isSilentlyUpdated: observable,
            setSilentHighlight: action,
            clearSilentHighlight: action,
        })
    }

    setSilentHighlight({ isNewlyAdded = false, isSilentlyUpdated = false } = {}) {
        this.isNewlyAdded = isNewlyAdded
        this.isSilentlyUpdated = isSilentlyUpdated
    }

    clearSilentHighlight() {
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false
    }

    formatDate(date) {
        this.createdAt = dateFormattedSlash(date)
    }

    static fromJson({ id, configuration, destination, type }) {
        const metadata = destination?.metadata && JSON.parse(destination.metadata)

        const notification = new Notification(id, configuration, destination, metadata, type)

        notification.formatDate(configuration?.createdAt)
        return notification
    }
}

export default Notification
